import React from "react"

import "./HorarioComponent.css"
import DayComponent from "./DayComponent"
import { Typography } from "@mui/material"
import { CircularProgress } from "@mui/material"
import Stack from "@mui/material/Stack"

import { db } from "../../../firebase/firebase_config.js"
import { collection, getDocs, orderBy, query } from "firebase/firestore"

const getDaysOfTheWeek = () => {
	var original_date = new Date() // get current date
	var monday_day = original_date.getDate() - original_date.getDay() + 1 // First day is the day of the month - the day of the week (+1 to start weeks on Monday)
	var thuesday_day = monday_day + 1 //Martes
	var friday_day = monday_day + 4 //Viernes
	var saturday_day = monday_day + 5 //Sabado
	//var last = first + 6 // last day is the first day + 6
	//console.log(thuesday_day, friday_day, saturday_day)
	var thuesday = new Date(
		original_date.getFullYear(),
		original_date.getMonth(),
		thuesday_day
	) //Martes
	var friday = new Date(
		original_date.getFullYear(),
		original_date.getMonth(),
		friday_day
	) //Viernes
	var saturday = new Date(
		original_date.getFullYear(),
		original_date.getMonth(),
		saturday_day
	) //Sabado

	var thuesday_txt = thuesday.toLocaleDateString("es-ES")
	var friday_txt = friday.toLocaleDateString("es-ES")
	var saturday_txt = saturday.toLocaleDateString("es-ES")

	return [thuesday_txt, friday_txt, saturday_txt]
}

class HorarioComponent extends React.Component {
	state = {
		loading: true,
		schedule: {},
	}

	async componentDidMount() {
		const schedule_ret = await this.getscheduleData()
		this.setState({ loading: false, schedule: schedule_ret })
	}

	getscheduleData = async () => {
		let scheduleList = []
		try {
			const scheduleCollection = collection(db, "Schedule")
			const q = query(scheduleCollection, orderBy("ID", "asc"))
			await getDocs(q).then((snapshot) => {
				snapshot.forEach((doc) => {
					scheduleList.push({ ...doc.data(), id: doc.id })
				})
			})
		} catch (error) {
			console.log("Error fetching firestore data: " + error.message)
		}
		//console.log(scheduleList)
		return scheduleList
	}

	render() {
		const daysOfTheWeek = getDaysOfTheWeek()
		//console.log("days", daysOfTheWeek)
		//console.log(daysOfTheWeek)
		let scheduleComponents = <div>Adquiring data...</div>
		if (!this.state.loading) {
			scheduleComponents = this.state.schedule.map((n, indx) => (
				<DayComponent key={n.id} data={{ date: daysOfTheWeek[indx], ...n }} />
			))
		}
		return (
			<div className="horario-component-container">
				<div className="horario-component-main-cointainer">
					<div className="horario-component-container1">
						<div className="horario-component-introContainer">
							<h1 className="">Horarios de entrenamiento</h1>
							<span className="horario-component-introText">
								<span className="">
									<Stack spacing={2}>
										<Typography className="">
											En general, estos son los horarios de entrenamiento que
											tenemos definidos con la piscina. Es posible que algunas
											semanas tengamos permiso para entrenar algún sábado.
										</Typography>

										<Typography className="">
											Actualmente, los entrenos se llevan a cabo en la piscina
											del colegio Miramadrid de Paracuellos del Jarama (Madrid).
										</Typography>

										<Typography className="">
											La lista de apuntados se resetea cada domingo y se
											presentan los siguientes días de la semana que se entrena.
										</Typography>

										<Typography className="">
											¡Apúntate aquí a tu entrenamiento!
										</Typography>

										<Typography fontSize={12} className="">
											*Necesitas estar registrado para apuntarte a un
											entrenamiento.
										</Typography>
									</Stack>

									<br></br>
									<br></br>
								</span>
							</span>
						</div>
						<div className="horario-component-daysContainer">
							{this.state.loading ? <CircularProgress /> : scheduleComponents}
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default HorarioComponent
